<template>
  <div class="course-overview-card-comp" @click="navToCoursePostDetail">
    <div class="left">
      <img class="intro" :src="introImg" />
    </div>

    <div class="center">
      <div class="title">{{ title }}</div>
      <div class="tag" :class="[mallCourse.mall_course.type]">
        {{ service.showCourseTypeLabel(mallCourse.mall_course.type) }}
      </div>
      <div class="date-time">{{ mallCourse.mall_course.address }}</div>
    </div>

    <div class="right" v-if="showProgress">
      <progress-status-tag type="point" status="progress"></progress-status-tag>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import ProgressStatusTag from '@/views/my-gift/components/ProgressStatusTag.vue'
import { IMallCourseOrderItem } from 'kuaidong-model'
import { CourseCenterService } from 'kuaidong-service'
@Component({
  components: { ProgressStatusTag },
})
export default class CourseOverviewCardComp extends BaseComponent {
  @Prop()
  mallCourse!: IMallCourseOrderItem

  @Prop({ type: String, default: 'course' })
  type!: 'order' | 'course'

  get showProgress() {
    return this.type === 'course'
  }

  get introImg() {
    if (this.type === 'course') {
      return this.mallCourse.mall_course.cover_path
    } else {
      return this.mallCourse.sku_pic
    }
  }

  get title() {
    if (this.type === 'course') {
      return this.mallCourse.mall_course.title
    } else {
      return this.mallCourse.sku_name
    }
  }
  get service() {
    return CourseCenterService
  }

  navToCoursePostDetail() {
    this.$router.push({
      name: 'course_order_detail',
      query: {
        orderId: this.mallCourse.out_order_id,
      },
    })
  }
}
</script>
<style lang="less">
.course-overview-card-comp {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  > .left {
    margin-right: 12px;
    flex-shrink: 0;

    > .intro {
      width: 80px;
      height: 80px;
      border-radius: 8px;
    }
  }

  > .center {
    display: flex;
    flex-direction: column;
    margin-right: 16px;
    justify-content: flex-start;
    flex: 1;
    > .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #2d2f33;
      width: 157px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-align: left;
    }
    > .tag {
      margin-top: 8px;
      background: #eaf6fd;
      border-radius: 4px;
      padding: 2px 4px;
      font-weight: 500;
      font-size: 10px;
      line-height: 16px;
      color: #57a2f7;
      width: 48px;
      &.offline_course {
        background: #e4fae1;
        color: #4dd238;
      }
    }
    > .date-time {
      margin-top: 15px;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #8f8f8f;
      text-align: left;
    }
  }

  > .right {
    flex-shrink: 0;
    flex-grow: 1;
    > .progress-status-tag-comp {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>
